export default __webpack_public_path__ + "static/media/data-storage-tab.ea8a359f.png";